import { call, put, takeEvery, delay, select, take, cancel, fork } from 'redux-saga/effects';
import {
  CREATE_PRE_LAYOUT,
  CREATE_DECAP_GROUP,
  DELETE_DECAP_GROUP,
  SAVE_DECAP_GROUP,
  UPDATE_VRM_VOLTAGE,
  UPDATE_BALL,
  OPEN_PRE_LAYOUT,
  UPDATE_DC_COMPONENTS,
  UPDATE_DC_NETS,
  CREATE_POWER_NET,
  SAVE_PRELAYOUT_BACKEND,
  UPDATE_POWER_NET_NAME,
  DELETE_POWER_NET,
  UPDATE_PORTS,
  UPDATE_PRE_LAYOUT_TYPE
} from './actionTypes';
import projectDesigns from '@/services/helper/projectDesigns';
import { PRE_LAYOUT } from '../../../../constants/designVendor';
import { getDefaultName } from '../../../../services/helper/setDefaultName';
import { AC_PRE_LAYOUT_VERSION, DC_PRE_LAYOUT_VERSION } from '../../../../version';
import { PRE_LAYOUT_DESIGN_VERSION, PreLayoutBall, PreLayoutContent, PreLayoutModel, initDecapGroup, initNewPreLayout } from '../../../../services/Cascade/prelayout';
import { getCascadePreLayout, saveCascadePreLayout } from '../../../../services/Cascade/prelayout/prelayoutCtrl';
import { openPage, openProject, updateExpand, updateSelectKeys, updateViewList } from '../project/action';
import { DC, PACKAGE, PACKAGES, PCB, PCBS, PCB_PRE_LAYOUT } from '../../../../constants/treeConstants';
import designConstructor from '../../../../services/helper/designConstructor';
import { firstOpenPreLayout, showDecapGroup, updateCanvasStatus, updatePreLayoutContent } from './action';
import { getViewListBySelectedKey } from '../../../../services/helper/filterHelper';
import preLayoutData from '../../../../services/Cascade/prelayout/preLayoutData';
import { message } from 'antd';
import { SCHEMATIC, SPICE } from '../../../../services/Cascade/prelayout/constants';

let autoSaveTask = null
function* createPreLayout(action) {
  const { CascadeReducer: { project: { openProjectId, selectedKeys, viewList, expandedKeys } } } = yield select();
  const { designType, electric } = action;

  const designs = projectDesigns.getDesigns(openProjectId);
  const designNames = designs.filter(d => d.vendor === PRE_LAYOUT).map(d => d.name);
  const name = getDefaultName({ nameList: designNames, defaultKey: "PreLayout", key: "" });
  const _designType = designType === PACKAGES ? PACKAGE : PCB;

  const data = {
    id: "",
    name,
    projectId: openProjectId,
    version: electric === DC ? DC_PRE_LAYOUT_VERSION : AC_PRE_LAYOUT_VERSION,
    designVersion: PRE_LAYOUT_DESIGN_VERSION,
    type: _designType,
    electric,
    preLayoutType: SCHEMATIC,
    content: initNewPreLayout(_designType, electric)
  }
  try {
    const res = yield call(saveCascadePreLayout, data);

    //re open project -> update design list
    yield put(openProject(openProjectId));

    //if PCB not expand, expand PCB
    if (!expandedKeys.includes(`${designType}-${openProjectId}`)) {
      const expandKeys = [...expandedKeys, `${designType === PCB ? PCBS : PACKAGES}-${openProjectId}`];
      yield put(updateExpand(expandKeys));
    }

    if (res) {
      const designID = res.id;
      yield put(updatePreLayoutContent({ ...data, id: designID, groupShow: "" }));
      designConstructor.addDesign(designID, { ...data, ...res });
      projectDesigns.addDesign(openProjectId, { ...data, ...res })

      //open current pre layout
      let selectKeys = []
      if (viewList.length <= 1) {
        selectKeys = [`${PCB_PRE_LAYOUT}-${designID}`]
      } else {
        selectKeys = selectedKeys.filter(item => !item.match(PCB) && !item.match(PACKAGE) && !item.match(PCB_PRE_LAYOUT));
        selectKeys = [...selectKeys, `${PCB_PRE_LAYOUT}-${designID}`];
      }

      yield put(updateSelectKeys(selectKeys));
      yield put(updateViewList(getViewListBySelectedKey(selectKeys)));

      yield put(openPage({ pageType: PCB_PRE_LAYOUT, id: designID }));
      yield delay(300)
      yield put(firstOpenPreLayout(true));
    }
  } catch (e) {
    console.error("Create PreLayout failed:" + e)
  }
}

function* openPreLayout(action) {
  const { id } = action;
  if (!id) {
    return;
  }
  if (autoSaveTask) {
    yield cancel(autoSaveTask);
  }
  try {
    yield put(updateCanvasStatus(false));
    const res = yield call(getCascadePreLayout, id);
    if (res) {
      preLayoutData.savePreLayout(id, res);
      yield put(updatePreLayoutContent({ ...res, groupShow: "", preLayoutType: res.preLayoutType || SCHEMATIC }));
      autoSaveTask = yield fork(autoSave);
      yield delay(200);
      yield put(updateCanvasStatus(true));
    }
  } catch (e) {
    console.error("Open PreLayout failed:" + e);
  }
}

function* autoSave() {
  let lastTask;
  while (true) {
    const newAction = yield take([SAVE_PRELAYOUT_BACKEND]);
    let delayTime = 2000;
    if (newAction.type === SAVE_PRELAYOUT_BACKEND) {
      delayTime = 2000;
      if (lastTask) {
        yield cancel(lastTask);
      }
      lastTask = yield fork(debounce, delayTime, savePreLayout, newAction);
    }
  }
};

function* debounce(time = 0, callback, info) {
  yield delay(time);
  yield call(callback, info);
}

function* savePreLayout(action) {
  const { CascadeReducer: { project: { openProjectId }, prelayout } } = yield select();
  const { id, name, type, content, electric, preLayoutType } = prelayout;

  try {
    const data = {
      id: id,
      name,
      projectId: openProjectId,
      version: electric === DC ? DC_PRE_LAYOUT_VERSION : AC_PRE_LAYOUT_VERSION,
      designVersion: PRE_LAYOUT_DESIGN_VERSION,
      electric,
      type,
      preLayoutType,
      content: new PreLayoutContent(content)
    }
    const res = yield call(saveCascadePreLayout, data);
    if (res) {
      preLayoutData.savePreLayout(id, data);
    }
  } catch (e) {
    console.error("Save PreLayout failed:" + e);
  }
}

function* createNewDecapGroup(action) {
  const { powerNet } = action
  const { CascadeReducer: { prelayout: { content } } } = yield select();
  const { decapGroups, referenceNets, powerNets } = content;
  const groupNames = decapGroups.map(item => item.name);
  const newGroupName = getDefaultName({ nameList: groupNames, defaultKey: 'DecapGroup_', key: "" });
  const newGroup = initDecapGroup(powerNet, referenceNets[0], newGroupName);
  let data = { ...content };
  data.decapGroups = [...data.decapGroups, newGroup].sort((a, b) => {
    const aIndex = powerNets.findIndex(n => n === a.powerNet);
    const bIndex = powerNets.findIndex(n => n === b.powerNet);
    return aIndex === bIndex ? 0 : (aIndex > -1 ? aIndex : Infinity) > (bIndex > -1 ? bIndex : Infinity) ? 1 : -1;
  })
  yield put(updatePreLayoutContent({ content: data }));
  yield put(showDecapGroup(newGroupName));
  yield put(updateCanvasStatus(true));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* createNewPowerNet() {
  const { CascadeReducer: { prelayout: { content, type } } } = yield select();
  const { powerNets, referenceNets } = content;
  const powerNetName = getDefaultName({ nameList: powerNets, defaultKey: type === PACKAGE ? 'VCC' : 'VDD', key: "" });
  let data = { ...content };
  data.powerNets.push(powerNetName);
  data.components.forEach(component => {
    component.pins = component.pins.filter(pin => [...powerNets, ...referenceNets].includes(pin.net));
    if (!component.pins.some(pin => pin.net === powerNetName)) {
      component.pins.push({ pin: powerNetName, net: powerNetName, pinName: powerNetName, node: "" })
    }
  })

  const model = data.model || {}
  const newPowerNets = data.powerNets || []
  data.model = new PreLayoutModel({ ...model, powerNets: newPowerNets })

  yield put(updatePreLayoutContent({ content: data }));
  yield put(updateCanvasStatus(true));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* deleteDecapGroup() {
  const { CascadeReducer: { prelayout: { groupShow, content = {} } } } = yield select();
  const { decapGroups } = content;
  const newGroups = decapGroups.filter(item => item.name !== groupShow);
  let data = { ...content };
  data.decapGroups = newGroups
  yield put(updatePreLayoutContent({ content: data }));
  yield put(showDecapGroup(""));
  yield put(updateCanvasStatus(true));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* saveDecapGroup(action) {
  const { group } = action;
  const { CascadeReducer: { prelayout: { groupShow, content = {} } } } = yield select();
  const { decapGroups, powerNets } = content;
  const groupIndex = decapGroups.findIndex(item => item.name === groupShow);
  if (!group.name) {
    const groupNames = decapGroups.map(item => item.name);
    const newGroupName = getDefaultName({ nameList: groupNames, defaultKey: 'DecapGroup_', key: "" });
    group.name = newGroupName;
  }
  let data = { ...content };
  data.decapGroups[groupIndex] = group
  data.decapGroups.sort((a, b) => {
    const aIndex = powerNets.findIndex(n => n === a.powerNet);
    const bIndex = powerNets.findIndex(n => n === b.powerNet);
    return aIndex === bIndex ? 0 : (aIndex > -1 ? aIndex : Infinity) > (bIndex > -1 ? bIndex : Infinity) ? 1 : -1;
  })
  yield put(updatePreLayoutContent({ content: data }));
  yield put(showDecapGroup(group ? group.name : ''));
  yield put(updateCanvasStatus(true));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* updateVRMVoltage(action) {
  const { name, voltage } = action;
  const { CascadeReducer: { prelayout: { content = {} } } } = yield select();
  const data = { ...content };
  const voltages = data.voltages || {};
  data.voltages = { ...voltages, [name]: voltage }
  yield put(updatePreLayoutContent({ content: data }));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* updateBall(action) {
  const { value, key, powerNet } = action;
  const { CascadeReducer: { prelayout: { content = {} } } } = yield select();
  const data = { ...content };
  const _ball = data.balls[powerNet] || {}
  data.balls[powerNet] = new PreLayoutBall({ ..._ball, [key]: value });
  yield put(updatePreLayoutContent({ content: data }));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* updatePowerNetName(action) {
  const { name, newName } = action;
  const { CascadeReducer: { prelayout: { content = {} } } } = yield select();
  const data = { ...content };
  if (data.powerNets.includes(newName)) {
    message.error(`Same power net name is exsit.`)
    return;
  }
  const findIndex = data.powerNets.findIndex(net => net === name);
  if (findIndex > -1) {
    data.powerNets[findIndex] = newName;

    const _ball = data.balls[name] || {};
    delete data.balls[name];
    data.balls[newName] = new PreLayoutBall({ ..._ball });

    data.components.forEach(component => {
      component.pins = component.pins.filter(pin => ![name].includes(pin.net));
      component.pins.push({ pin: newName, net: newName, pinName: newName, node: "" })
    })

    data.decapGroups = data.decapGroups.map(group => {
      if (group.powerNet === name) {
        return { ...group, powerNet: newName }
      }
      return group
    })

    if (data.model && Object.keys(data.model).length > 0) {
      data.model.ports = (data.model.ports || []).map(p => {
        return p.powerNet === name ? { ...p, powerNet: newName } : p;
      });
    }

    yield put(updatePreLayoutContent({ content: data }));
    yield put({ type: SAVE_PRELAYOUT_BACKEND });
  }
}

function* deletePowerNet(action) {
  const { name } = action;
  const { CascadeReducer: { prelayout: { groupShow, content = {} } } } = yield select();
  const data = { ...content };
  data.powerNets = data.powerNets.filter(net => net !== name);

  delete data.balls[name];

  data.components.forEach(component => {
    component.pins = component.pins.filter(pin => ![name].includes(pin.net));
  })

  data.decapGroups = data.decapGroups.filter(group => group.powerNet !== name)

  if (data.model && Object.keys(data.model).length > 0) {
    data.model.ports = (data.model.ports || []).filter(p => p.powerNet !== name);
    data.model.files = data.model.files || [];
  }

  yield put(updatePreLayoutContent({ content: data }));
  if (!data.decapGroups.find(item => item.name === groupShow)) {
    yield put(showDecapGroup(""));
  }
  yield put(updateCanvasStatus(true));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* updateDcComponents(action) {
  const { comp } = action;
  const { CascadeReducer: { prelayout: { content = {} } } } = yield select();
  const { components, nets } = content;

  const findIndex = components.findIndex(item => item.id === comp.id);
  if (findIndex < 0) {
    return;
  }
  const oldComp = JSON.parse(JSON.stringify(components[findIndex]))
  components[findIndex] = comp;

  const newNets = nets.map(net => {
    const { components } = net;
    const _components = components.filter(c => c !== oldComp.name);
    return { ...net, components: [..._components, comp.name] }
  })
  const data = { ...content, components, nets: newNets };
  yield put(updatePreLayoutContent({ content: data }));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* updateDcNets(action) {
  const { net } = action;
  const { CascadeReducer: { prelayout: { content = {} } } } = yield select();
  const { components, nets } = content;

  const findIndex = nets.findIndex(item => item.id === net.id);

  if (findIndex < 0) {
    return;
  }
  const oldNet = JSON.parse(JSON.stringify(nets[findIndex]))
  nets[findIndex] = net;

  const newComponents = components.map(comp => {
    const { pins } = comp;
    const _pins = pins.filter(pin => pin.net !== oldNet.name);

    return { ...comp, pins: [..._pins, { pin: net.name, pinName: net.name, net: net.name, node: "" }] }
  })
  const data = { ...content, nets, components: newComponents };
  yield put(updatePreLayoutContent({ content: data }));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* updatePorts(action) {
  const { files, ports } = action;

  const { CascadeReducer: { prelayout: { content = {} } } } = yield select();
  const data = { ...content };
  data.model = { files, ports }
  yield put(updatePreLayoutContent({ content: data }));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* updatePreLayoutType(action) {
  const { preLayoutType } = action
  const { CascadeReducer: { prelayout: { content = {} } } } = yield select();
  const data = { ...content };
  if (preLayoutType === SPICE) {
    const model = data.model || {}
    const powerNets = data.powerNets || []
    data.model = new PreLayoutModel({ ...model, powerNets: powerNets })
  }
  yield put(updatePreLayoutContent({ preLayoutType: preLayoutType, content: data, groupShow: "" }));
  yield put({ type: SAVE_PRELAYOUT_BACKEND });
}

function* CascadePreLayoutSaga() {
  yield takeEvery(CREATE_PRE_LAYOUT, createPreLayout);
  yield takeEvery(OPEN_PRE_LAYOUT, openPreLayout);

  // AC
  yield takeEvery(CREATE_DECAP_GROUP, createNewDecapGroup);
  yield takeEvery(DELETE_DECAP_GROUP, deleteDecapGroup);
  yield takeEvery(SAVE_DECAP_GROUP, saveDecapGroup);
  yield takeEvery(UPDATE_VRM_VOLTAGE, updateVRMVoltage);
  yield takeEvery(UPDATE_BALL, updateBall);
  yield takeEvery(CREATE_POWER_NET, createNewPowerNet);
  yield takeEvery(UPDATE_POWER_NET_NAME, updatePowerNetName);
  yield takeEvery(DELETE_POWER_NET, deletePowerNet)
  yield takeEvery(UPDATE_PORTS, updatePorts)
  yield takeEvery(UPDATE_PRE_LAYOUT_TYPE, updatePreLayoutType)

  //DC
  yield takeEvery(UPDATE_DC_COMPONENTS, updateDcComponents);
  yield takeEvery(UPDATE_DC_NETS, updateDcNets);
}

export default CascadePreLayoutSaga;